import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { CARD_BRANDS } from 'universal/cfs-card'
import { ReactComponent as VisaSvg } from 'icons/card-brands/visa.svg'
import { ReactComponent as MasterCardSvg } from 'icons/card-brands/master-card.svg'

const cardBrandLogoCss = css`
  margin: 0 auto;
`

const cardBrandCss = {
  [CARD_BRANDS.VISA]: css`
    width: 4.375rem;
    height: 1.375rem;
  `,
  [CARD_BRANDS.MASTER_CARD]: css`
    width: 3rem;
    height: 2rem;
  `,
}

const cardBrandImages = {
  [CARD_BRANDS.VISA]: <VisaSvg />,
  [CARD_BRANDS.MASTER_CARD]: <MasterCardSvg />,
}

function CardBrandImage({ brandName }) {
  const brandCss = cardBrandCss[brandName]
  const brandImage = cardBrandImages[brandName]

  if (!brandCss || !brandImage) {
    return null
  }

  return <div css={css([cardBrandLogoCss, brandCss])}>{brandImage}</div>
}

CardBrandImage.propTypes = {
  brandName: PropTypes.string.isRequired,
}

export default CardBrandImage
